export default "__VITE_ASSET__bcb983f1__"